import React, { useState, useEffect } from "react";
import Modal from "react-modal";

// Components
import Button from "../Button/Button";

// Hooks
import useTheme from "../ThemeProvider/useTheme/useTheme";

// Utils
import { clientWidth } from "../../utils";
import { modalStyles } from "../../constants";

// Icons
import MapMarkerIcon from "../../icons/MapMarkerIcon";
import WaitListIcon from "../../shared/ui/wait-list-icon";

export function WaitlistModal({
  eventSummary,
  formattedDate,
  isOpen,
  onClose,
  onJoinWaitlist,
}) {
  const { theme } = useTheme();

  const customStyle =
    clientWidth() < theme.responsive.breakpoints.sm
      ? Object.assign(
          {},
          { ...modalStyles.newMobileDefault },
          {
            content: {
              ...modalStyles.newMobileDefault.content,
              // padding: "48px 24px 24px",
              padding: "24px",
              // top: "auto",
              // bottom: "0px",
            },
          }
        )
      : Object.assign(
          {},
          { ...modalStyles.default },
          {
            content: {
              ...modalStyles.default.content,
              width: "400px",
              // padding: "40px 24px 24px",
              padding: "24px",
            },
          }
        );

  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setIsModalOpen(isOpen);
  }, [isOpen]);

  const handleClose = () => {
    setIsModalOpen(false);
    if (onClose) onClose();
  };

  const handleJoinWaitlist = () => {
    if (onJoinWaitlist) {
      onJoinWaitlist();
    }
    handleClose();
  };

  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={handleClose}
      style={customStyle}
      contentLabel="Join Waitlist"
      className="tbk-fixed tbk-flex tbk-flex-col tbk-items-center tbk-rounded-2xl tbk-bg-basic-white tbk-p-6 tbk-shadow-trube tbk-outline-none lg:tbk-relative"
      closeTimeoutMS={300}
    >
      {/* Close button */}
      {/* <button
        onClick={handleClose}
        className="tbk-absolute tbk-right-4 tbk-top-4 tbk-text-xl tbk-text-grey hover:tbk-text-grey-inactive"
      >
        ✕
      </button> */}

      <WaitListIcon width={64} height={64} className="tbk-text-blue-grey" />

      {/* Content */}
      <div className="tbk-w-full tbk-text-center">
        {/* Заголовок */}
        <h2 className="tbk-text-h3-subtitle tbk-mb-2 tbk-mt-4 tbk-text-primary">
          Waitlist
        </h2>

        <div className="tbk-text-main tbk-mb-4 tbk-text-blue-grey">
          Thank you for joining the waitlist! You'll be notified if a spot
          becomes available.
        </div>

        {eventSummary && (
          <div className="tbk-mb-6 tbk-rounded-lg tbk-border tbk-border-blue-grey-light tbk-p-4 tbk-text-left">
            <div className="tbk-text-title-medium tbk-mb-2 tbk-text-primary">
              {eventSummary.location?.name || eventSummary.name}
            </div>

            <div className="tbk-text-main tbk-mb-2 tbk-text-primary">
              {formattedDate && formattedDate[0]}
            </div>

            <div className="tbk-text-main tbk-mb-2 tbk-text-primary">
              {formattedDate && formattedDate[1]}
            </div>

            {eventSummary.location?.address && (
              <div className="tbk-items-top tbk-text-main-linked tbk-flex tbk-text-blue-grey">
                <MapMarkerIcon className="tbk-mr-1 tbk-shrink-0" />
                <span>{eventSummary.location.address}</span>
              </div>
            )}
          </div>
        )}

        {/* Кнопка OK */}
        <Button
          className="tbk-w-full tbk-pl-5 tbk-pr-5"
          onClick={handleJoinWaitlist}
        >
          Ok
        </Button>
      </div>
    </Modal>
  );
}
